import { ItfSceneProductCardInput } from '@elem/compCommon/SceneProducts/type';

export interface AuProductCardItem extends ItfSceneProductCardInput {
    productId: string;
    variantId: string;
    handle?: string;
    /** 蓝色规格行，可选 */
    label?: string;
    skuTitle: string;
    desc: string[];
    /** Works Best With 文案，可选 */
    worksWith?: string;
}

export const POWER_GENERATION_PRODUCTS: AuProductCardItem[] = [
    {
        productId: '8766029693126',
        variantId: '45479883047110',
        handle: 'ecoflow-110w-lightweight-portable-solar-panel',
        skuTitle: 'EcoFlow 110W Lightweight Portable Solar Panel',
        desc: ['High 23% conversion rate', 'Self-supporting with an adjustable angle', 'Lightweight at 4 kg, 10% smaller than similar panels'],
        worksWith: 'EcoFlow DELTA, EcoFlow RIVER 2, EcoFlow RIVER 2 Max',
    },
    {
        productId: '8745653731526',
        variantId: '45411591848134',
        handle: 'ecoflow-220w-lightweight-portable-solar-panel',
        skuTitle: 'EcoFlow 220W Lightweight Portable Solar Panel',
        desc: ['High 23% conversion rate', "Durable tempered glass that's built to last", 'Capture up to 25% more solar.'],
        worksWith: 'EcoFlow RIVER 2 Pro, EcoFlow DELTA 2, EcoFlow DELTA 2 Max, EcoFlow DELTA Pro',
    },
];

export const POWER_USAGE_PRODUCTS: AuProductCardItem[] = [
    {
        productId: '8576144933062',
        variantId: '44890284556486',
        handle: 'wave-3-portable-air-conditioner',
        skuTitle: 'EcoFlow WAVE 3 Portable Air Conditioner',
        desc: ['8 hours of continuous wireless use', 'Rapid temperature change in just 15 minutes.'],
    },
    {
        productId: '8576134119622',
        variantId: '44891647672518',
        handle: 'glacier-classic-portable-fridge-freezer',
        skuTitle: 'EcoFlow GLACIER Classic Portable Refrigerator',
        desc: ['Dual-Zone Design', 'Holds up to 90 cans (55L)'],
    },
];
